import Vue from "vue";
import DrxBanner, { getActiveBanners } from "./";

window.addEventListener("DOMContentLoaded", async () => {
  const mountingElement = document.getElementById("navbar-drx-banner");

  if (!mountingElement) {
    return;
  }

  const activeBanners = getActiveBanners();

  if (activeBanners.length === 0) {
    return;
  }

  new Vue({
    el: "#navbar-drx-banner",
    render: function (createElement) {
      return createElement(
        "div",
        activeBanners.map((config) => createElement(DrxBanner, { props: { data: config.data }, key: config.id }))
      );
    },
  });
});
